import React from 'react';
interface Props {
  showLeftShadow: boolean;
  showRightShadow: boolean;
}
export const ScrollShadow: React.FC<Props> = ({
  showLeftShadow,
  showRightShadow
}) => {
  return <>
      {showLeftShadow && <div className="pointer-events-none absolute inset-y-0 left-0 w-10 bg-gradient-to-r from-white to-transparent"></div>}
      {showRightShadow && <div className="pointer-events-none absolute inset-y-0 right-0 w-10 bg-gradient-to-l from-white to-transparent"></div>}
    </>;
};